import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  BookOpen, ArrowLeft, LogOut,
  LayoutDashboard, CreditCard, FileText, BarChart3
} from 'lucide-react';

export function LedgerSidebar({ onLogout, onBackToPlatforms }) {
  const menuItems = [
    { path: '/',             icon: LayoutDashboard, label: 'Ledger',            end: true },
    { path: '/transactions', icon: CreditCard,       label: 'Transactions'               },
    { path: '/statement',    icon: FileText,          label: 'Account Statement'          },
    { path: '/reports',      icon: BarChart3,         label: 'Financial Report'           },
  ];

  return (
    <div className="w-64 bg-gradient-to-b from-purple-900 to-pink-800 text-white flex flex-col">
      {/* Header */}
      <div className="p-6 border-b border-purple-700">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <BookOpen size={22} className="text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold bg-gradient-to-r from-purple-200 to-pink-200 bg-clip-text text-transparent">
              Ledger
            </h1>
            <p className="text-purple-300 text-xs">Accounting & Finance</p>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 p-4 space-y-2">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) =>
              `flex items-center px-4 py-3 rounded-lg transition-all duration-200 ${
                isActive
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 shadow-lg'
                  : 'hover:bg-purple-800'
              }`
            }
          >
            <item.icon size={20} className="mr-3" />
            <span className="font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Bottom */}
      <div className="p-4 border-t border-purple-700 space-y-2">
        <button
          onClick={onBackToPlatforms}
          className="flex items-center w-full px-4 py-3 rounded-lg hover:bg-purple-700 transition-colors text-purple-200"
        >
          <ArrowLeft size={20} className="mr-3" />
          <span className="font-medium">Change Platform</span>
        </button>
        <button
          onClick={onLogout}
          className="flex items-center w-full px-4 py-3 rounded-lg hover:bg-red-600 transition-colors"
        >
          <LogOut size={20} className="mr-3" />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </div>
  );
}

export default LedgerSidebar;